// @ts-check
/** @typedef {{ title?: React.ReactNode, onBack?: () => void, onClose?: () => void }} Props */
/** @param {Props} props */
export default function Header({ title, onBack, onClose }) {
  return (
    <div className="sb-pop-up-wrapper__heading-layout">
      <div className="sb-pop-up-wrapper__icon" onClick={() => onBack?.()}>
        {onBack && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M15 5L9.16667 12L15 19"
              stroke="#111111"
              strokeWidth="1.5"
              strokeLinecap="square"
            ></path>
          </svg>
        )}
      </div>
      <div className="sb-pop-up-wrapper__heading">{title}</div>
      <button
        className="sb-pop-up-wrapper__icon"
        type="button"
        style={{
          background: 'none',
          border: 'none',
          visibility: onClose ? 'visible' : 'hidden',
        }}
        tabIndex={onClose ? 0 : -1}
        aria-hidden={!onClose}
        disabled={!onClose}
        onClick={onClose}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path d="M5 5.00024L19.1421 19.1424" stroke="#111111" strokeWidth="1.5"></path>
          <path d="M5 19.1424L19.1421 5.00024" stroke="#111111" strokeWidth="1.5"></path>
        </svg>
      </button>
    </div>
  )
}
